var map = {
	"./en-US/announcementMessages.ts": 47040,
	"./en-US/claimGroupMessages.ts": 26248,
	"./en-US/claimMessages.ts": 33795,
	"./en-US/confirmAccountMessages.ts": 66556,
	"./en-US/customClaimMessages.ts": 95002,
	"./en-US/dataTableMessages.ts": 49627,
	"./en-US/expiredSessionMessages.ts": 50340,
	"./en-US/filterMessages.ts": 70969,
	"./en-US/formUserMessages.ts": 74953,
	"./en-US/globalMessages.ts": 10708,
	"./en-US/index.ts": 58079,
	"./en-US/launcherMessages.ts": 31099,
	"./en-US/loginMessages.ts": 25254,
	"./en-US/maintenanceUserMessages.ts": 47127,
	"./en-US/permissionGroupMessages.ts": 5529,
	"./en-US/roleFormMessages.ts": 21073,
	"./en-US/roleRegisterMessages.ts": 87994,
	"./en-US/tenantSelectionMessages.ts": 21001,
	"./en-US/userFormMessages.ts": 36678,
	"./en-US/userRegisterMessages.ts": 98861,
	"./en-US/userRightsMessages.ts": 83911,
	"./en-US/yupMessages.ts": 15777,
	"./es/announcementMessages.ts": 84272,
	"./es/claimGroupMessages.ts": 13368,
	"./es/claimMessages.ts": 32915,
	"./es/confirmAccountMessages.ts": 86508,
	"./es/customClaimMessages.ts": 78666,
	"./es/dataTableMessages.ts": 54699,
	"./es/expiredSessionMessages.ts": 43508,
	"./es/filterMessages.ts": 3497,
	"./es/formUserMessages.ts": 95078,
	"./es/globalMessages.ts": 78660,
	"./es/index.ts": 3887,
	"./es/launcherMessages.ts": 57195,
	"./es/loginMessages.ts": 15510,
	"./es/maintenanceUserMessages.ts": 19303,
	"./es/permissionGroupMessages.ts": 20489,
	"./es/roleFormMessages.ts": 86849,
	"./es/roleRegisterMessages.ts": 1610,
	"./es/tenantSelectionMessages.ts": 71865,
	"./es/userFormMessages.ts": 36214,
	"./es/userRegisterMessages.ts": 18461,
	"./es/userRightsMessages.ts": 20535,
	"./es/yupMessages.ts": 31505,
	"./i18n.ts": 11024,
	"./interfaces/announcementMessages.ts": 85824,
	"./interfaces/claimGroupMessages.ts": 91944,
	"./interfaces/claimMessages.ts": 89027,
	"./interfaces/confirmAccountMessages.ts": 75388,
	"./interfaces/customClaimMessages.ts": 23322,
	"./interfaces/dataTableMessages.ts": 11227,
	"./interfaces/expiredSessionMessages.ts": 59172,
	"./interfaces/filterMessages.ts": 27609,
	"./interfaces/formUserMessages.ts": 69238,
	"./interfaces/globalMessages.ts": 67348,
	"./interfaces/index.ts": 17919,
	"./interfaces/launcherMessages.ts": 3003,
	"./interfaces/loginMessages.ts": 80486,
	"./interfaces/maintenanceUserMessages.ts": 8311,
	"./interfaces/permissionGroupMessages.ts": 66713,
	"./interfaces/roleFormMessages.ts": 92977,
	"./interfaces/roleRegisterMessages.ts": 43130,
	"./interfaces/tenantSelectionMessages.ts": 98537,
	"./interfaces/userFormMessages.ts": 8582,
	"./interfaces/userRegisterMessages.ts": 53997,
	"./interfaces/userRightsMessages.ts": 49607,
	"./interfaces/yupMessages.ts": 11169,
	"./languageData.ts": 90179,
	"./pt-BR/announcementMessages.ts": 60663,
	"./pt-BR/claimGroupMessages.ts": 65251,
	"./pt-BR/claimMessages.ts": 16294,
	"./pt-BR/confirmAccountMessages.ts": 61559,
	"./pt-BR/customClaimMessages.ts": 93295,
	"./pt-BR/dataTableMessages.ts": 47126,
	"./pt-BR/expiredSessionMessages.ts": 59699,
	"./pt-BR/filterMessages.ts": 88878,
	"./pt-BR/formUserMessages.ts": 76169,
	"./pt-BR/globalMessages.ts": 52715,
	"./pt-BR/index.ts": 33517,
	"./pt-BR/launcherMessages.ts": 32448,
	"./pt-BR/loginMessages.ts": 28191,
	"./pt-BR/maintenanceUserMessages.ts": 52826,
	"./pt-BR/permissionGroupMessages.ts": 61172,
	"./pt-BR/roleFormMessages.ts": 85338,
	"./pt-BR/roleRegisterMessages.ts": 91769,
	"./pt-BR/tenantSelectionMessages.ts": 63316,
	"./pt-BR/userFormMessages.ts": 69689,
	"./pt-BR/userRegisterMessages.ts": 22994,
	"./pt-BR/userRightsMessages.ts": 42936,
	"./pt-BR/yupMessages.ts": 96120,
	"./useTranslation.ts": 43830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56903;